type MenuItem = {
    name: string;
    description: string;
    price: number;
    image: string;
};

export const menuItems: MenuItem[] = [
    {
        name: "#12. Chicken Chilis",
        description: "Craft beer elit seitan exercitation photo booth et 8-bit kale chips.",
        price: 20,
        image: "img/1.png"
    },
    {
        name: "#10. Fried Rice",
        description: "Craft beer elit seitan exercitation photo booth et 8-bit kale chips.",
        price: 33,
        image: "img/2.png"
    },
    {
        name: "#13. Mashed Onions",
        description: "Craft beer elit seitan exercitation photo booth et 8-bit kale chips.",
        price: 23,
        image: "img/3.png"
    },
    {
        name: "#32. Vegetable fry",
        description: "Craft beer elit seitan exercitation photo booth et 8-bit kale chips.",
        price: 10,
        image: "img/4.png"
    },
    {
        name: "#15. Burger Cury",
        description: "Craft beer elit seitan exercitation photo booth et 8-bit kale chips.",
        price: 15,
        image: "img/5.png"
    },
    {
        name: "#9. Potato Soup",
        description: "Craft beer elit seitan exercitation photo booth et 8-bit kale chips.",
        price: 57,
        image: "img/6.png"
    }
];